import { render, staticRenderFns } from "./TabStaticLegacy.vue?vue&type=template&id=425e05a8"
import script from "./TabStaticLegacy.vue?vue&type=script&lang=js"
export * from "./TabStaticLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports